import React,{useContext, useEffect, useState} from 'react'
import styled from '@emotion/styled'
import { Box } from '@mui/system'
import { Alert, AlertTitle, Backdrop, Button, Checkbox, Dialog, Divider, duration, FormControlLabel, TextField, Typography } from '@mui/material'
import ProfileContext from '../../context/ProfileContext'
import OverloadTable from '../../components/tables/100/OverloadTable'
import { useLocation, useNavigate } from 'react-router-dom'
import ImportModal from '../../components/100/ImportModal';
import useAuth from '../../hooks/useAuth'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import PaymentRate from '../../components/tables/100/PaymentRate'
import ExtensionAgreementTable from '../../components/tables/100/ExtensionAgreementTable'
import ViewPDF from '../../components/1000/ViewPDF';
import RejectRequest from '../../components/1000/RejectRequest';

import { useFormik } from 'formik'

const Agreement=styled(Box)(({theme})=>({
    display:'flex',
    flexDirection:'column',
    gap:'20px',
    alignSelf:'center',
    width:'90%',
    borderRadius:'5px',
    // background:theme.palette.background.bread,
     borderTop: `0.5px solid ${theme.palette.third.light}`,
    boxShadow: `0px 4px 4px ${theme.palette.background.shadow}`,
    padding:'15px 20px 100px 20px'
}))
const Header=styled(Box)(({theme})=>({
    width:'100%',
    height: '80px',
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '20px',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexWrap:'wrap',
}))
const Information=styled(Typography)(({theme})=>({
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '17px',
    lineHeight: '28px',
    color:theme.palette.primary.darkFade,
    "& ol":
    {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '15px',
    lineHeight: '28px',
    }
}))
const List=styled('li')(({theme})=>({
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '28px',
    marginLeft:'5%',
    color:theme.palette.primary.main,
    padding:'15px 5px',
    borderBottom: `0.5px solid ${ theme.palette.third.light}`

}))
const StyledForm=styled('form')(({theme})=>({
    display:'flex',
    gap:'20px',
    flexWrap:'wrap',
}))
const StyledTextField=styled(TextField)(({theme})=>({
    "& input":{
        width:'400px'
    },
    "& label":{
        color: theme.palette.third.main,
        fontWeight: '400',
        fontSize: '15px',
        lineHeight: '20px',
    }
}))
const Buttons=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'flex-end',
    width:'100%',
    gap:'15px',
    margin:'10px 5px'

}))

export default function ExtensionOfficeAgreement() {
  const api=useAxiosPrivate()
  const [rankData,setRankData]=useState([])
  const [payment,setPayment]=useState(0)
  const [info,setInfo]=useState()
  const[open,setOpen]=useState(false)
  const[rejectOpen,setRejectOpen]=useState(false)
  const {state:profileStatus}=useContext(ProfileContext);
  const {host}=profileStatus
  const {state: {doc_id,rejected,view,request_year,request_semester,email}}=useLocation();
  const navigate=useNavigate();
  const [state,setState]=useState({
      first_name:"",
  middle_name:"",
  last_name:"",
  college:"",
  dep:"",
  rank:"",
  mobile:"",
  pic:"",
  email:"",
  calendar:{
    year:"",
    semester:"",
    duration:"",
    start_date:"",
    end_date:"",
    n_weeks:"",
  },
  details:{
    load: 0,
    n_groups:0,
    a_research:0,
    expectedLoad:0,
    payment_rate:0,
    position_load:0,
    research_load:0,
    academic_load:0,
    leh:0,
  }
  });
  // const{college,rank,dep,mobile,position}=state;
  // const name=`${state?.first_name} ${state?.middle_name} ${state?.last_name}`
  // const{year, semester,duration,n_weeks,start_date,end_date}=state?.calendar;
  // const {expectedLoad,payment_rate,leh,load,position_load,research_load,academic_load}=state?.details;
  // const overload=load>expectedLoad?load-expectedLoad:0;
    const acceptTerms=async()=>{
                api
          .patch(`/request/officeAgree/${doc_id}`)
          .then((response) => {
            navigate('/office_approval/extensionsOffice', {state:{id:doc_id,message:"The agreement has been filled"}})
          })
        }
    const {user,changed}=useAuth();
    const [data,setData]=useState()
    useEffect(()=>{
        let isMounted=true;
        const controller=new AbortController();
        const getData=async ()=>{
          try{
            const profile=await api.get(`profile/viewAgreement/${email}?semester=${request_semester}&year=${request_year}`,{
              signal:controller.signal
            })
            const response=await api.get(`request/path/${doc_id}`,{
              signal:controller.signal
            })
            const info=await api.get(`request/partTimeInfo/?year=${request_year}&semester=${request_semester}`,{
              signal:controller.signal
            })
            // console.log(profile.data)
            isMounted &&  setState(profile.data)
            isMounted &&  setData(response.data)
            isMounted &&  setRankData(info.data?.rank)
            isMounted &&  setInfo({weeks:info.data?.weeks?.no_weeks,rate:info.data?.rate?.expected_load})
          }
          catch(err){
            console.error(err)
          }
        }
        getData();
        return ()=>{
          isMounted=false;
          controller.abort()
        }
          },[changed])
  

    const rankOptions = {
      filter:false,
      selectableRows:'none',
      rowsPerPage:3,
      rowsPerPageOptions:[3,10,20,40],
      rowHover:false,
      responsive:'vertical',
      pagination:false,
};
    const [agree,setAgree]=useState(false);
    const formik = useFormik({
        enableReinitialize:true,
        initialValues: {
          name:`${state?.first_name} ${state?.middle_name} ${state?.last_name}`,
          rank:state?.rank,
          college:state?.college,
          dep:state?.dep,
          year:state?.calendar?.year,
          semester:state?.calendar?.semester,
          mobile:state?.mobile,
        },
      });
  return (
    <Agreement>
        <Header>
            Extension Contract Agreement Form
        </Header>
        <StyledForm>
        <StyledTextField
          disabled
          id="name"
          label="Instructor's Name"
          variant="standard"
          value={formik.values.name}
        />
        <StyledTextField
          disabled
          id="rank"
          label="Academic Rank"
          variant="standard"
          value={formik.values.rank}
        />
        <StyledTextField
          disabled
          id="college"
          label="College"
          variant="standard"
          value={formik.values.college}
        />
         <StyledTextField
          disabled
          id="dep"
          label="Department"
          variant="standard"
          value={formik.values.dep}
        />
        <StyledTextField
          disabled
          id="year"
          label="Academic Year"
          variant="standard"
          value={formik.values.year}
        />
        <StyledTextField
          disabled
          id="semester"
          label="Semester Term"
          variant="standard"
          value={formik.values.semester}
        />
        <StyledTextField
          disabled
          id="mobile"
          label="Mobile"
          variant="standard"
          value={formik.values.mobile}
        />
        </StyledForm>
        <Information>
            {`Addis Ababa Science.and Technology University is pleased to hire the above instructor 
            (Hereafter referred to as employee) for rendering intellectual services for Regular program of the University.
             The University is obliged to pay the appropriate sum of money for the services the employee rendered.`}
        </Information>
        <Information
        sx={{marginLeft:'20px',}}
        >
         <ol>
            <li> {`The agreement shall be made as per the payment rate given bellow:`}
              <PaymentRate 
              options={rankOptions} 
              title="Payment Rate"
              data={rankData}
              setPayment={()=>setPayment()}
              />
           </li>
           <li> {`The assignment given  to you is as follows:`}
              <ExtensionAgreementTable 
              title={view?"Load Assignment":"Current Assignment"} 
              type="Extension"
              year={request_year}
              semester={request_semester}
              info={info}
              payment_rate={state?.details?.payment_rate}
              setPayment={setPayment}
              />
           </li>
           <li>{`The Normal period of the semester is from ${0} to ${0} during which based on the
                 Academic Rank the University will pay the employee a gross sum of birr ${payment}, 
                 (${payment/4}) 
                 payable in four installments and subject to income tax deductions.`}
            </li>
            <li>{
            `
            The amount payable shall depend on the total number of Lecture and Lab/Tutorial hours conducted by the Employee
            `
              }</li>
           <li> {`In addition to the above assignments, the Employee shall invigilate examination as assigned; 
                 submit copies of any handouts, test and exam papers, student grades any related documents to the
                  Department head.`}</li>
            <li> {`If the employee fails to perform his/her duties properly, the University has the right to take a
            ny measures including terminating the contract. `}</li>
           <li> {`If the program is suspended beyond the control of the University, this contract will be ceased accordingly `}</li>
         </ol>
         {!view &&        
         <Button variant="contained" component="label" sx={{
            width:'180px',
            marginTop:'20px',
            bgcolor:'third.main',
            "& : hover":{
              bgcolor:'gray',
             }  
           }}
           onClick={()=>{setOpen(true)}}
           >
            View Attachment
            </Button>}
        </Information>
 {
          view?
          <ul>
            <Information>Approvals</Information>
          <List>
            {`The Instructor has agreed to all the terms stated above at: ${data?.date}`}
            </List>
            {data?.offices?.map((office)=>{
              return(
                <List >
                  {`The ${office.owner} ${office.state===true?`has agreed to all the terms stated above at ${office.date}`:rejected?`has rejected the terms stated above.`:`has not yet agreed to the terms stated above.`}`}
                </List>
              )
            })}
          </ul>: 
          <ul>   
            <List>
            {`The Instructor has agreed to all the terms stated above at: ${data?.date}`}
            </List>   
            {data?.offices?.map((office)=>{
              return(
                office?.state===true?
                <List>
                  {`The ${office.owner} has agreed to all the terms stated above at ${office.date}`}
                </List> :
                <FormControlLabel control={<Checkbox 
                      color='secondary' 
                      value={agree}
                      onChange={()=>setAgree(!agree)}
                      sx={{color:'third.main', }}
                      />} 
                      label="I approve the agreement according to the terms stated above" 
              />             
              )
            })}
        </ul>
        }

  
        <Buttons>
                <Button variant="contained"
                    size="medium"
                    onClick={()=>setRejectOpen(true)}
                    sx={{
                    fontWeight: 400,
                    color:'#fff',
                    bgcolor:'gray',
                    "&:hover":{
                    bgcolor:'darkGray'}}}
                >Reject</Button>
                {
                  view?
                  <Button variant="contained"
                  size="medium"
                  sx={{
                  bgcolor:'secondary.main',
                  fontWeight: 400,
                  color:'#fff',
                  "&:hover":{
                  bgcolor:'secondary.hover',}, }}
                  >Print </Button>:
                  <Button 
                  onClick={()=>acceptTerms()}
                  variant="contained"
                      disabled={!agree}
                      size="medium"
                      sx={{
                      bgcolor:'secondary.main',
                      fontWeight: 400,
                      color:'#fff',
                      "&:hover":{
                      bgcolor:'secondary.hover',}, }}
                      >Submit </Button>
                }
        </Buttons>
        <Backdrop 
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={(event)=>{event.target.className==="MuiBackdrop-root css-1ji7omv-MuiBackdrop-root" && setOpen(false)}}
        >
         {
          data?.attachment?
          <ViewPDF className="display" close={{ setOpen: setOpen, host:host, attachment:data?.attachment, token:`?token=${user?.accessToken}` }} />:
          <Alert severity="error" sx={{width:"20%", fontSize:"16px"}}>
                    <AlertTitle sx={{fontSize:"20px"}}>Error</AlertTitle>
            File Not Found
          </Alert>
         }
         </Backdrop>
        <Backdrop 
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={rejectOpen}
        onClick={(event)=>{event.target.className==="MuiBackdrop-root css-1ji7omv-MuiBackdrop-root" && setRejectOpen(false)}}
        >
          <RejectRequest close={setRejectOpen} doc_id={doc_id} path={`/office_approval/extensionsOffice`}/>
         </Backdrop>
    </Agreement>
  )
}
